import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

export default class extends Controller {
    static targets = [
        "firstName", "lastName", "middleName", "uniCode", "label",
        "btnRemove", "btnUpdate"
    ]

    connect() {
        this.labelTarget.classList.add('hidden')
    }

    async remove(event) {
        event.preventDefault()
        if (!window.confirm('Are you sure?')) return

        this.setLoading(true)

        const payload = {
            user: {
                agent_info_attributes: {
                    co_leader: false,
                    co_first_name: '',
                    co_last_name: '',
                    co_middle_name: '',
                    co_uni_code: '',
                }
            }
        }

        const success = await this.performUpdate(payload)

        if (success) {
            this.firstNameTarget.value = ''
            this.lastNameTarget.value = ''
            this.middleNameTarget.value = ''
            this.uniCodeTarget.value = ''
            this.flashSuccess()
        }

        this.setLoading(false)
    }

    async update(event) {
        event.preventDefault()
        this.setLoading(true)

        const payload = {
            user: {
                agent_info_attributes: {
                    co_leader: true,
                    co_first_name: this.firstNameTarget.value,
                    co_last_name: this.lastNameTarget.value,
                    co_middle_name: this.middleNameTarget.value,
                    co_uni_code: this.uniCodeTarget.value,
                }
            }
        }

        const success = await this.performUpdate(payload)

        if (success) {
            this.flashSuccess()
        }

        this.setLoading(false)
    }

    async performUpdate(payload) {
        try {
            const response = await fetch('/users/update_co_leader', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': this.csrfToken
                },
                body: JSON.stringify(payload)
            })
            return response.ok
        } catch (error) {
            console.error("Co-leader update failed:", error)
            return false
        }
    }

    flashSuccess() {
        enter(this.labelTarget).then(() => {
            setTimeout(() => {
                leave(this.labelTarget)
            }, 1800)
        })
    }

    setLoading(isLoading) {
        this.btnUpdateTarget.disabled = isLoading
        this.btnUpdateTarget.innerHTML = isLoading ? '...' : 'Update'
        this.btnRemoveTarget.disabled = isLoading
    }

    get csrfToken() {
        return document.querySelector('meta[name="csrf-token"]')?.content
    }
}